export default __webpack_public_path__ + "static/media/elevate-dmb-2.f6cdecc2.png";